export var StatusType;
(function (StatusType) {
    StatusType["InProgress"] = "InProgress";
    StatusType["Success"] = "Success";
    StatusType["Draft"] = "Draft";
    StatusType["Completed"] = "Completed";
    StatusType["Error"] = "Error";
    StatusType["Warning"] = "Warning";
})(StatusType || (StatusType = {}));
